<script setup lang="ts">
  const { t } = useI18n();

  useHead({
    title: t('SALARY_CALCULATOR_PAGE.TITLE'),
    meta: [{ name: 'description', content: t('SALARY_CALCULATOR_PAGE.DESCRIPTION') }],
  });

  useSeoMeta({
    ogTitle: t('SALARY_CALCULATOR_PAGE.TITLE'),
    ogDescription: t('SALARY_CALCULATOR_PAGE.DESCRIPTION'),
  });
</script>

<template>
  <Calculator mode="salary" />
</template>
